import { Course, Data, Player, TeamGameMatch } from '../../../database.schema';
import { useFetchData } from '../tournament-data';

export type MatchEntryDataData = {
  team1: Array<Player>;
  team2: Array<Player>;
  playersPerTeam: number;
  nextResultIndex: number;
  courses: Array<Course>;
};

export const useFetchMatchEntryData = (selectedIndex: number) => {
  return useFetchData((data: Data): MatchEntryDataData => {
    const results = data.tournaments[selectedIndex]?.ryderCup?.results;
    const courses = data.courses;
    const team1PlayerIds = data?.tournaments[selectedIndex]?.ryderCup?.team1.playerIds;
    const team2PlayerIds = data?.tournaments[selectedIndex]?.ryderCup?.team2.playerIds;
    if (team1PlayerIds && team2PlayerIds) {
      const team1 = team1PlayerIds.map((playerId: number) => {
        return data.players.find((player: Player) => player.id === playerId) ?? ({} as Player);
      });
      const team2 = team2PlayerIds.map((playerId: number) => {
        return data.players.find((player: Player) => player.id === playerId) ?? ({} as Player);
      });

      return {
        team1,
        team2,
        playersPerTeam: team1.length,
        nextResultIndex: results?.length ?? 0,
        courses,
      };
    } else {
      return {
        team1: [],
        team2: [],
        playersPerTeam: 0,
        nextResultIndex: 0,
        courses,
      };
    }
  });
};

export type TierMatchData = {
  match: TeamGameMatch;
  courses: Array<Course>;
};

export const useFetchTierPointsMatchEntryData = (selectedTournamentIndex: number, matchIndex: number) => {
  return useFetchData((data: Data): TierMatchData | null => {
    const matches = data.tournaments[selectedTournamentIndex]?.teamGames?.matches;
    const courses = data.courses;
    if (matches && matches[matchIndex]) {
      return {
        match: matches[matchIndex],
        courses,
      };
    } else {
      return null;
    }
  });
};
